import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ExtendedModule, FlexModule } from '@ngbracket/ngx-layout';
import { IconModule } from '@abhinavakhil/iconify-angular';
import { TopbarComponent } from './topbar/topbar.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { ToolbarUserModule } from '../../../@vex/layout/toolbar/toolbar-user/toolbar-user.module';
import { ToolbarNotificationsModule } from '../../../@vex/layout/toolbar/toolbar-notifications/toolbar-notifications.module';
import { NavigationItemModule } from '../../../@vex/components/navigation-item/navigation-item.module';
// QuicklinkModule désactivé temporairement - incompatible avec Angular 14
// import { QuicklinkModule } from 'ngx-quicklink';
import { NavigationModule } from '../../../@vex/layout/navigation/navigation.module';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { StatusBarItemComponent } from './status-bar-item/status-bar-item.component';
import { IconWarningComponent } from './icon-warning/icon-warning.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TabBadgeComponent } from './tab-badge/tab-badge.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { BaseModule } from '../base/base.module';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatBadgeModule } from '@angular/material/badge';
import { BadgeComponent } from './vex-badge/vex-badge.component';
import { CatalogComponent } from './catalog/catalog.component';
import { CatalogBasketComponent } from './catalog/component/catalog-basket/catalog-basket.component';
import { CatalogActionsComponent } from './catalog/component/catalog-actions/catalog-actions.component';
import { BasketWithDetailsComponent } from './basket-with-details/basket-with-details.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { ErrorNotificationComponent } from './error-notification/error-notification.component';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { StatusToTextPipe } from '../enums/basketRowStatusEnum';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { EquipmentCreateUpdateDeleteComponent } from '../../pages/application/management/equipment/equipment-create-update-delete/equipment-create-update-delete.component';
import { TreeCheckboxComponent } from './tree-checkbox/tree-checkbox.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatTreeModule } from '@angular/material/tree';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    TopbarComponent,
    SkeletonComponent,
    StatusBarItemComponent,
    IconWarningComponent,
    TabBadgeComponent,
    SearchBarComponent,
    TreeCheckboxComponent,
    ErrorNotificationComponent,
    BadgeComponent,
    CatalogComponent,
    CatalogBasketComponent,
    CatalogActionsComponent,
    BasketWithDetailsComponent,
    StatusToTextPipe,
    EquipmentCreateUpdateDeleteComponent,
  ],
  exports: [
    TopbarComponent,
    SkeletonComponent,
    StatusBarItemComponent,
    IconWarningComponent,
    TabBadgeComponent,
    SearchBarComponent,
    TreeCheckboxComponent,
    BadgeComponent,
    CatalogComponent,
    CatalogBasketComponent,
    CatalogActionsComponent,
    BasketWithDetailsComponent,
    ErrorNotificationComponent,
    EquipmentCreateUpdateDeleteComponent,
    StatusToTextPipe,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FlexModule,
    IconModule,
    MatMenuModule,
    NavigationModule,
    ExtendedModule,
    ToolbarUserModule,
    ToolbarNotificationsModule,
    NavigationItemModule,
    RouterModule, // Remplace QuicklinkModule (désactivé - incompatible Angular 14)
    MatTooltipModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    BaseModule,
    MatChipsModule,
    MatBadgeModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatTabsModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatTreeModule,
    MatDividerModule,
    MatListModule,
  ],
})
export class UiModule {}
